module.exports = __webpack_public_path__ + "img/item_bookCover_11.0d27cff9.jpeg";